import { PageHeaderNavigationTab } from 'cdk-radial';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { PageHeader } from 'components/PageHeader';
import { getStoreId } from 'components/StoreSelect/slice';
import { setDueDate } from 'pages/VendorsTablePage/components/VendorsTable/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getSelectedTab, setSelectedTab } from './slice';
import { useTabOptions } from './useTabOptions';
import type { PageHeaderTabOption } from 'pages/VendorsTablePage/types';

export const LandingPageHeader = (): React.JSX.Element => {
  const selectedTab = useAppSelector(getSelectedTab);
  const storeId = useAppSelector(getStoreId);
  const dispatch = useAppDispatch();
  const history = useHistory();

  const tabOptions = useTabOptions();

  const onTabClick = useCallback(
    (tabId: string, path: string) => {
      if (storeId) {
        history.push(path);
        dispatch(setSelectedTab(tabId));
        dispatch(setDueDate(''));
      }
    },
    [dispatch, history, storeId]
  );

  return (
    <PageHeader>
      {tabOptions.map(({ id, label, path }: PageHeaderTabOption) => (
        <PageHeaderNavigationTab
          id={id}
          isActive={id === selectedTab}
          key={id}
          label={label}
          onClick={() => onTabClick(id, path)}
          onFocus={() => {}}
        />
      ))}
    </PageHeader>
  );
};

export default LandingPageHeader;
